// Module
var code = "<button type=\"button\" class=\"btn\" ref=\"button\">\n    <i ref=\"icon\" class=\"fa-width-auto\" aria-hidden=\"true\"></i>\n</button>";
// Exports
module.exports = code;